import { Factory } from '../../services/Factory';

export interface IDateTimePickerScope extends angular.IScope {
    ngModel: any;
    project;
}

export class DateTimePicker implements angular.IDirective {
    public restrict:string = 'E';
    public link:(scope:IDateTimePickerScope, element: angular.IAugmentedJQuery, attrs: any) => void;
    public template:string;
    public scope = { ngModel: '=', project: '=' };
    public require = ['ngModel'];

    constructor() {
        this.template = "<div class='input-group input-group-sm date'><input type='text' class='form-control' onkeydown='return false'/><span class='input-group-addon'><span class='fa fa-calendar'></span></span></div>";
        this.link = (scope: IDateTimePickerScope, element: angular.IAugmentedJQuery, attrs: any) => {
            scope.zeroTime = 'zeroTime' in attrs;
            scope.endOfDay = 'endOfDay' in attrs;

            // With replace:true gone, element is the <iio-date-time-picker> wrapper.
            // The bootstrap-datetimepicker plugin must be initialized on the inner
            // .input-group.date element; dp.change events bubble up to element so the
            // listener below still works unchanged.
            const pickerEl = element.find('.input-group.date');
            (pickerEl as any).datetimepicker({
                icons: {
                    time: "fa fa-clock-o",
                    date: "fa fa-calendar",
                    up: "fa fa-arrow-up",
                    down: "fa fa-arrow-down",
                    previous: "fa fa-arrow-left",
                    next: "fa fa-arrow-right"
                },
                viewMode: 'years',
                format: 'MMM Do YYYY',
                defaultDate: scope.ngModel ? Date.parse(moment.tz(moment.utc(scope.ngModel), moment.tz.utc).format("MM/DD/YYYY, h:mm:ss a")) : null
            });

            element.on("dp.change", (value: any) => {

                if (scope.zeroTime) {
                    let date = moment.tz(value.date.format('YYYY-MM-DD'), scope.project.timezoneId);
                    if (scope.endOfDay) {
                        date = date.endOf('day');
                    }
                    scope.ngModel = date;
                } else {
                    let selectedDate = value.date.toDate();
                    let date = new Date();
                    scope.ngModel = moment(new Date(selectedDate.getFullYear(), selectedDate.getMonth(), selectedDate.getDate(), date.getHours(), date.getMinutes(), date.getSeconds(), date.getMilliseconds())).toDate();
                }

                scope.$apply();
            });
        };
    }
}

frontendApp.directive("iioDateTimePicker", [Factory.Create(DateTimePicker)]);
